import {IApiEndpoint, IOperationResponse,} from "@localization/siteMap/siteMapInterfaces.ts";
import {IToken} from "@models/IToken.ts";
import dayjs from "dayjs";

export const siteMapApi = {
		GetQueryString: (endpoint: IApiEndpoint): string => {
			let url = '';
			if (endpoint.query) {
				const queryString = Object.entries(endpoint.query).filter(([_key, value]) => value).map(([key, value]) => {
					if (Array.isArray(value)) {
						return value.map(val => {
							if (typeof val == "object") {
								return `${key}=${JSON.stringify(val)}`;
							}

							return `${key}=${val}`;
						}).join("&");
					}
					if (typeof value == 'boolean') {
						return `${key}=${value}`;
					}

					if (typeof value != "string" || value == 'undefined') {
						return ''
					}

					return `${key}=${value}`;
				}).filter(x => x != '').join("&");
				url += `${queryString}`;
				if (queryString != '' && endpoint.pagination?.page && endpoint.pagination?.pageSize) {
					url += "&";
				}
			}
			return url;
		},
		GetObjectsInQuery: (endpoint: IApiEndpoint) => {
			const objects: any[] = []
			if (endpoint.query) {
				Object.entries(endpoint.query).filter(([_key, value]) => value).map(([key, value]) => {
					if (Array.isArray(value)) {
						value.map(val => {
							if (typeof val == "object") {
								objects.push(value)
							}
						}).join("&");
					}
					if (typeof value == "object") {
						objects.push(value)
					}

					return `${key}=${value}`;
				})
			}
			return objects;
		},
		buildEndpoint: (endpoint: IApiEndpoint): string => {

			let url = `/proxy${endpoint.url}`;

			if (endpoint.data && endpoint['method'] == "GET") {
				const data = endpoint.data.data != null ? Object.entries(endpoint.data.data).filter(([_key, value]) => value).map(([key, value]) => {
					if (Array.isArray(value)) {
						return value.map(val => `data.${key}=${val}`).join("&");
					}
					return `data.${key}=${value}`;
				}).join("&") : '';
				const querystring = endpoint.query != null ? siteMapApi.GetQueryString(endpoint) : ''
				// const querystring = endpoint.query != null ? Object.entries(endpoint.query).filter(([_key, value]) => value).map(([key, value]) => {
				//     if (Array.isArray(value)) {
				//         return value.map(val => `query.${key}=${val}`).join("&");
				//     }
				//     return `query.${key}=${value}`;
				// }).join("&") : '';

				const pagination = endpoint.data.pagination ? `&page=${endpoint.data.pagination?.page}&pageSize=${endpoint.data.pagination?.pageSize}` : '';
				const includes = endpoint.data.include ? `&includes=${endpoint.data.include.join(",")}` : '';
				const orderBy = endpoint.data.orderBy ? `&orderBy=${endpoint.data.orderBy}` : '';

				url += `?${data}${querystring}${pagination}${includes}${orderBy}`;
				return url;
			}

			if (endpoint.path && endpoint.path.length > 0) {
				url += "/" + endpoint.path.join("/");
			}
			url += "?";

			if (endpoint.query) {
				url += siteMapApi.GetQueryString(endpoint);
			}

			if (endpoint.pagination && endpoint.pagination.page && endpoint.pagination.pageSize) {
				url += `page=${endpoint.pagination?.page}&pageSize=${endpoint.pagination?.pageSize}`;
			}

			return url;
		},
		buildFetchOptions:
			(endpoint: IApiEndpoint): RequestInit => {
				const token = sessionStorage.getItem('token');

				const bearer = token ? JSON.parse(token) as IToken : {token: '', expira: dayjs().add(1, 'day')} as IToken;

				const ignoreCacheFromData = endpoint.data?.pagination?.ignoreCache
				const ignoreCacheFromLegacy = endpoint.pagination?.ignoreCache

				const shouldIgnoreCache = ignoreCacheFromData ?? ignoreCacheFromLegacy

				if (endpoint.data != null) {
					if (endpoint.method == 'GET') {
						return {
							method: endpoint.method,
							headers: {
								'Content-Type': 'application/json',
								'authorization': `Bearer ${bearer.token}`,
								'Cache-Control': shouldIgnoreCache ? 'no-cache' : 'default',
							},
							cache: shouldIgnoreCache ? 'no-cache' : 'default',
						}
					}
					return {
						method: endpoint.method,
						headers: {
							'Content-Type': 'application/json',
							'authorization': `Bearer ${bearer.token}`,
							'Cache-Control': shouldIgnoreCache ? 'no-cache' : 'default',
						},
						body: JSON.stringify({
							data: endpoint.data.data,
							includes: endpoint.data.include ?? {},
							orderBy: endpoint.data.orderBy ?? {},
						})
					}
				}

				return {
					method: endpoint.method,
					headers: {
						'Content-Type': 'application/json',
						'authorization': `Bearer ${bearer.token}`,
						'Cache-Control': shouldIgnoreCache ? 'no-cache' : 'default',
					},
					cache: shouldIgnoreCache ? 'no-cache' : 'default',
					body: endpoint.body ? JSON.stringify(endpoint.body) : undefined,
				};
			},
		/**
		 * @deprecated usar o request
		 * @see siteMapApi.request
		 */
		async fetch<T = IOperationResponse<any>>(endpoint
		                                         :
		                                         IApiEndpoint, retry
		                                         :
		                                         boolean = false
		):
			Promise<T> {

			const url = siteMapApi.buildEndpoint(endpoint);
			const options = siteMapApi.buildFetchOptions(endpoint);

			const response = await fetch(url, {...options});

			if (response.status === 401 && !retry
			) {
				return siteMapApi.fetch(endpoint, true);
			}

			if (!response.ok) {
				const errorText = await response.text();
				const result = JSON.parse(errorText) as IOperationResponse<any>;

				if (result) {
					return result as T;
				}
			}

			return await response.json() as Promise<T>;
		},
		/**
		 * @deprecated
		 * @param endpoint
		 * @param retry
		 */
		async request<T = any>(endpoint
		                       :
		                       IApiEndpoint, retry
		                       :
		                       boolean = false
		):
			Promise<IOperationResponse<T>> {
			return siteMapApi.fetch<IOperationResponse<T>>(endpoint, retry);
		}
	}
;
